import { createUseStyles } from 'react-jss';

import type { LcpnTheme } from '../../styles/theme';
import { Button } from '../Button';
import { Typography } from '../Typography';

import { useUpdateNavigationBar } from './NavigationBarProvider';

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  dropDownMenu: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors['grey-100'],
    margin: theme.spacing(2, 2, 0, 2),
    padding: theme.spacing(2),
  },

  head: {
    display: 'flex',
    width: '100',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 0,
  },

  body: {
    width: '100%',
    backgroundColor: theme.colors.white,
    marginTop: theme.spacing(2),
  },

  [`@media screen and (max-width: ${theme.breakPoints.desktop}px)`]: {
    dropDownMenu: {
      '&&': { margin: 0, padding: 0 },
    },
    head: {
      '&&': {
        padding: theme.spacing(2, 0, 0, 4),
      },
    },
  },
}));

type Props = {
  title: string;
  children: JSX.Element | JSX.Element[];
};

export function DropDownMenu(props: Props) {
  const { resetNavigationBar } = useUpdateNavigationBar();

  const classes = useStyles();
  const { title, children } = props;
  return (
    <div className={classes.dropDownMenu}>
      <div className={classes.head}>
        <Typography variant="h4">{title}</Typography>
        <Button label="Close" onClick={() => resetNavigationBar()} />
      </div>
      <div className={classes.body}>{children}</div>
    </div>
  );
}
